import React, { useState, useEffect, useContext } from 'react';
import './RadioField.scss'
import { ConfigContext } from '../../screens/form/DynamicForm/DynamicForm'
import { Icon_Radio_Empty, Icon_Radio_Selected } from '../../../UI/screens/form/styles/assets/icons'
import HoverTip from '../hoverTip/hoverTip'


const RadioField = ({ label, id, fieldValue, formValue, formik, orgColor, physicianAction, formType, displayPurposeOtherField, setFileError, hoverTip }) => {
    const [selected, setSelected] = useState(false);
    const { dbFormSpec } = useContext(ConfigContext);

    orgColor = '#717275';

    useEffect(() => {
        formik.values.documentation && formik.values.documentation !== '1' && formik.setFieldValue('supportingDoc', [{}])
        formik.values.documentation === '1' && formik.setFieldValue('supportingDoc', "")
    }, [formik.values.documentation]);


    useEffect(() => {
        formik.values.documentationProxy && formik.values.documentationProxy !== '1' && formik.setFieldValue('supportingDocProxy', [{}])
        formik.values.documentationProxy === '1' && formik.setFieldValue('supportingDocProxy', "")
    }, [formik.values.documentationProxy]);

    // set default value do to page control being deleted.
    useEffect(() => { formik.setFieldValue(formik.values.documentation, '1'); }, []);

    useEffect(() => {
        if (id !== 'sensitiveInfo' && id !== 'someDocs' && id !== 'allDocs' && id !== 'requestPurposePdfOther' && id !== 'allPhys') {
            if (formik.values[formValue] !== fieldValue) {
                setSelected(false);
            }
        }
        if (id === 'sensitiveInfo') {
            // !formik.values.sensitiveInfo.some(...fieldValue) && setSelected(false)
            !formValue.every((e, i, a) => { return formik.values.sensitiveInfo.includes(e) }) && setSelected(false)
        }

        // if (id === ('allDocs' || 'someDocs')) {
        if (id === 'allDocs' || id === 'someDocs') {
            id === 'someDocs' && physicianAction.value === true && setSelected(false)
            id === 'allDocs' && physicianAction.value === false && setSelected(false)
        }

        if (id === 'someDocs') {
            physicianAction.value === false && setSelected(true);
        }
    })

    useEffect(() => {
        if (id === 'requestPurposePdfOther') {
            const standardRequestPurposes = ['1', '3', '4', '5', '6', '7']
            standardRequestPurposes.includes(formik.values.requestPurposePdf) && setSelected(false)
        }
    }, [formik.values.requestPurposePdf])

    useEffect(() => {
        if (id === 'allPhys') {
            formik.values.physicianList && formik.values.physicianList.includes('Physician List:') && setSelected(false)
        }
    })

    function RadioClickHandler() {
        if (id === 'recipient' && fieldValue === '1') {
            // formik.setFieldValue('discloseTo', "1")
            formik.values.discloseTo = "1";
            if (formType.includes('Patient')) {
                formik.setFieldValue('RFName', formik.values.PFName)
                formik.setFieldValue('RLName', formik.values.PLName)
                formik.setFieldValue('RName', `${formik.values.PFName} ${formik.values.PMName} ${formik.values.PLName}`)
                formik.setFieldValue('RPhone', formik.values.PPhone)
                formik.setFieldValue('REmail', formik.values.PEmail)
                formik.setFieldValue('RFax', formik.values.PFax)
                formik.setFieldValue('RAddress1', formik.values.PAddress1)
                formik.setFieldValue('RAddress2', formik.values.PAddress2)
                formik.setFieldValue('RCity', formik.values.PCity)
                formik.setFieldValue('RState', formik.values.PState)
                formik.setFieldValue('RZip', formik.values.PZip)
            }
            else {
                formik.setFieldValue('RName', `${formik.values.RepFName} ${formik.values.RepLName}`)
                formik.setFieldValue('RFName', formik.values.RepFName)
                formik.setFieldValue('RLName', formik.values.RepLName)
                formik.setFieldValue('RPhone', formik.values.RepPhone)
                formik.setFieldValue('REmail', formik.values.RepEmail)
                formik.setFieldValue('RFax', formik.values.RepFax)
                formik.setFieldValue('RAddress1', formik.values.RepAddress1)
                formik.setFieldValue('RAddress2', formik.values.RepAddress2)
                formik.setFieldValue('RCity', formik.values.RepCity)
                formik.setFieldValue('RState', formik.values.RepState)
                formik.setFieldValue('RZip', formik.values.RepZip)
            }
            setSelected(true)
        }
        else if (id === 'recipient' && fieldValue === '2') {
            // formik.setFieldValue('discloseTo', "2")
            formik.values.discloseTo = "2";
            formik.setFieldValue('RName', "")
            formik.setFieldValue('RFName', "")
            formik.setFieldValue('RLName', "")
            formik.setFieldValue('RPhone', "")
            formik.setFieldValue('REmail', "")
            formik.setFieldValue('RFax', "")
            formik.setFieldValue('RAddress1', "")
            formik.setFieldValue('RAddress2', "")
            formik.setFieldValue('RCity', "")
            formik.setFieldValue('RState', "")
            formik.setFieldValue('RZip', "")
            setSelected(true)
        }
        else if (id === 'deliveryMethod') {
            formik.setFieldValue('releasemodePdf', fieldValue)
            formik.setFieldValue('releasemode', fieldValue)

            setSelected(true)
        }
        else if (id === 'sensitiveInfo') {
            setSelected(true);
            formik.setFieldValue('sensitiveInfo', formValue);
          /*  document.getElementsByClassName('sens-checkbox').forEach((checkField) => { checkField.checked = true; });*/
        }
        else if (id === 'allDocs') {

            setSelected(true)
            formik.setFieldValue('inputPhysicianNames', 'All Doctors')
            for (let property in formik.values) {
                property.includes('physician#') && formik.setFieldValue(property, '')
            }
            physicianAction.toggle(true)
            // formValue.includes('discloseAll') && formik.setFieldValue('sensitiveInfo', ['discloseAll']);
            // formValue.includes('psy', 'drug', 'HIV', 'STD', 'genetics') && formik.setFieldValue('sensitiveInfo', ['psy', 'drug', 'HIV', 'STD', 'genetics']);
        }
        else if (id === 'someDocs') {
            setSelected(true)
            formik.setFieldValue('inputPhysicianNames', "")
            physicianAction.toggle(false)
            // formValue.includes('discloseAll') && formik.setFieldValue('sensitiveInfo', ['discloseAll']);
            // formValue.includes('psy', 'drug', 'HIV', 'STD', 'genetics') && formik.setFieldValue('sensitiveInfo', ['psy', 'drug', 'HIV', 'STD', 'genetics']);
        }
        else if (id === 'somePhys') {
            setSelected(true)
            formik.setFieldValue('physicianList', 'Physician List:')
        }
        else if (id === 'allPhys') {
            setSelected(true)
            if (formik.values.physicianList && !formik.values.physicianList.includes('Physician List:')) { setSelected(false) }
            if (formik.values.facilityOther && formik.values.facilityOther.length > 0) { formik.setFieldValue('facilityOther', '') }
            formik.setFieldValue('physicianList', 'All physicians')
        }
        else if (id === 'rrelationship') {
            setSelected(true)
            formik.setFieldValue('rrelationship', fieldValue)
        }
        else if (id === 'documentation') {
            setSelected(true)
            formik.setFieldValue('documentation', fieldValue)
            setFileError({ status: false, message: '' })
            // formik.values.documentation !== 1 && formik.setFieldValue('supportingDoc', [{}])
        }
        else if (id === 'documentationProxy') {
            setSelected(true)
            formik.setFieldValue('documentationProxy', fieldValue)
            setFileError({ status: false, message: '' })
            // formik.values.documentation !== 1 && formik.setFieldValue('supportingDoc', [{}])
        }
        else if (id === 'requestPurposePdf') {
            setSelected(true)
            displayPurposeOtherField(false);
            formik.setFieldValue('requestPurposePdf', fieldValue)
        }
        else if (id === 'requestPurposePdfOther') {
            setSelected(true)
            formik.setFieldValue('requestPurposePdf', '')
            displayPurposeOtherField(true);
        }
    }

    return (
        <label className={`radio-field2 subtitle2 ${selected && 'radio-selected'}`} >
            {selected ? <Icon_Radio_Selected /> : <Icon_Radio_Empty />}
            {/* {<Icon_Radio_Selected/>} */}
            {label}
            {/* {selected ? <SelectedRadio /> : <UnSelectedRadio />} */}
            <input onClick={
                () => RadioClickHandler()
            } type="radio" name={id} className='visually-hidden' />
            {/* <label htmlFor="radio-button">{label}</label> */}
            {(hoverTip) && <span onClick={(e) => { e.stopPropagation() }}><HoverTip popverLocation={null} tooltip={hoverTip} /></span>}
        </label>
    )
}

export default RadioField;


const UnSelectedRadio = () => {
    return (
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.5" cy="11.5" r="10.5" fill="#FDFDFD" stroke="#B3B3B3" stroke-width="2" />
        </svg>
    )
}

const SelectedRadio = () => {
    return (
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.5" cy="11.5" r="10.5" fill="#FDFDFD" stroke="#3A546E" stroke-width="2" />
            <circle cx="11.5" cy="11.5" r="6.5" fill="#3A546E" />
        </svg>
    )
}